import { Buffer } from 'buffer';
/**
 * Encodes data to Base64 string
 *
 * @param {object} data - object with the datat
 *
 * @returns {string} encoded string
 *
 * @example
 * toBase64({ a: 1 }) // returns "eyJhIjoxfQ=="
 */

export default function toBase64(data) {
  return Buffer.from(JSON.stringify(data)).toString('base64');
}